<template>
  <v-sheet
    class="file-drop-sheet"
    ref="dzone"
    :height="height"
    style="cursor: pointer;"
  >
    <input
      ref="upload"
      type="file"
      :accept="accept"
      style="display: none;"
    >
    <v-row
      class="mt-8"
      justify="center"
    >
      <v-icon
        v-if="!dragover"
        color="grey darken-2"
        size="40"
      >
        mdi-cloud-upload-outline
      </v-icon>
      <v-icon
        v-if="dragover"
        color="grey darken-2"
        size="40"
      >
        mdi-book-plus
      </v-icon>
    </v-row>
    <v-row
      class="mt-2"
      justify="center"
    >
      <span
        class="subtitle-2 grey--text text--darken-2"
      >Drop your file here or click to upload</span>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  props: ['accept'],
  data: () => ({
    height: 150,
    dragover: false,
    files: null,
  }),
  mounted() {
    const dropzone = this.$el;
    const fileupload = this.$el.firstElementChild;

    // Register listeners on dropzone / v-sheet
    if (dropzone) {
      // Register all drag & drop event listeners
      dropzone.addEventListener('dragenter', (e) => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener('dragleave', (e) => {
        e.preventDefault();
        this.dragover = false;
      });
      dropzone.addEventListener('dragover', (e) => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener('drop', (e) => {
        e.preventDefault();
        const dragevent = e;
        if (dragevent.dataTransfer) {
          this.filesSelected(dragevent.dataTransfer.files);
        }
      });

      // Register event listener for keyboard usage
      dropzone.addEventListener('click', (e) => {
        if (e.target.tagName === 'INPUT') return;
        e.preventDefault();
        if (fileupload) fileupload.click();
      });
      dropzone.addEventListener('keypress', (e) => {
        if (e.target.tagName === 'INPUT') return;
        e.preventDefault();
        const keyEvent = e;
        if (keyEvent.key === 'Enter') {
          if (fileupload) fileupload.click();
        }
      });

      // Register listeners on the file input
      if (fileupload) {
        fileupload.addEventListener('change', (e) => {
          const target = e.target;
          if (target.files) {
            this.filesSelected(target.files);
          }
        });
      }
    }
  },
  methods: {
    // Upload event
    filesSelected(fileList) {
      this.files = fileList;
      this.dragover = false;
      this.$emit('files-selected');
    },
  },
};
</script>

<style scoped>
.file-drop-sheet {
  width: 100%;
  border: 2px dashed #616161;
}
</style>
